import { useContext } from "react";
import { MinerPageContext } from "./MinerPageContextProvider";

const useMinerPageContext = () => {
  return useContext(MinerPageContext);
};

export default useMinerPageContext;
